import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { APIProvider } from "@vis.gl/react-google-maps";
import { Worker } from "@react-pdf-viewer/core";

import { ViewportProvider } from "./Contexts/ViewportContext";
import { AppUtilityContextProvider } from "./Contexts/AppUtilityContext";
import { SupportProvider } from "./Contexts/SupportProvider";
import { ModalContextProvider } from "./Contexts/ModalContext";
import { CustomSnackbarProvider } from "./Contexts/CustomSnackbarContext";
import { AdminStateProvider } from "./Contexts/AdminStateContext";

import Routes from "./routes";

import ScrollToTop from "./Components/Others/scroll-to-top";
import AdminStatePanel from "./Organisms/Admin Panel/admin-state-panel";

import UXCamLib from "./Utils/ux-cam-lib";
import BranchIOLib from "./Utils/branch-io";
import HeapAnalytics from "./Utils/heap-analytics-lib";
import Coralogix from "./Utils/coralogix";

import "./App.scss";
import '@react-pdf-viewer/core/lib/styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const isDev = process.env.REACT_APP_ENV === "development" || process.env.NODE_ENV === "development";

function AppContent() {
  return (
    <div id="portal-target-node">
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
        <QueryClientProvider client={queryClient}>
          <ViewportProvider>
            <BrowserRouter>
              <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={["places"]}>
                <AppUtilityContextProvider>
                  <SupportProvider>
                    <ModalContextProvider>
                      <CustomSnackbarProvider>
                        <ScrollToTop />
                        <Routes />
                      </CustomSnackbarProvider>
                    </ModalContextProvider>
                  </SupportProvider>
                </AppUtilityContextProvider>
              </APIProvider>
            </BrowserRouter>
          </ViewportProvider>
          <ReactQueryDevtools />
          {isDev && <AdminStatePanel />}
        </QueryClientProvider>
      </Worker>
      <UXCamLib />
      <BranchIOLib />
      <HeapAnalytics />
      <Coralogix />
      <div className="app-background"></div>
    </div>
  );
}

function App() {
  if (isDev) {
    return (
      <AdminStateProvider>
        <AppContent />
      </AdminStateProvider>
    );
  }
  return <AppContent />;
}

export default App;
